import { useEffect, useState } from 'react';

/**
 * Global SSE connection status (see App.tsx, 'logistrade_sse_status' event). Starts at `true`
 * (assumes connected) so a "disconnected" indicator doesn't flash during the first render before
 * the EventSource fires its first onopen/onerror.
 */
export const useSSEConnectionStatus = (): boolean => {
  const [connected, setConnected] = useState(true);

  useEffect(() => {
    const handler = (event: Event) => {
      const detail = (event as CustomEvent<{ connected: boolean }>).detail;
      if (detail) setConnected(detail.connected);
    };
    window.addEventListener('logistrade_sse_status', handler);
    return () => window.removeEventListener('logistrade_sse_status', handler);
  }, []);

  return connected;
};
